import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navigation from "@/components/Navigation";

import { logger } from "@/lib/logger";
import { useLanguage } from "@/i18n/LanguageContext";

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    logger.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-foreground text-background">
      <Navigation />
      <div className="text-center pt-20">
        <h1 className="mb-4 text-4xl font-bold">{t("notFound.title")}</h1>
        <p className="mb-4 text-xl text-background/70">{t("notFound.message")}</p>
        <a href="/" className="text-accent underline hover:text-accent/80">

          {t("notFound.returnHome")}
        </a>
      </div>
    </div>
  );
};

export default NotFound;
